import { useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Generate a session ID for the browser session
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('page_session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('page_session_id', sessionId);
  }
  return sessionId;
};

export const usePageView = (pageName) => {
  useEffect(() => {
    const trackPageView = async () => {
      try {
        const sessionId = getSessionId();
        await axios.post(
          `${API}/track-view`,
          null,
          {
            params: { page: pageName, session_id: sessionId },
            withCredentials: true
          }
        );
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.debug('Page view tracking error:', error);
      }
    };

    trackPageView();
  }, [pageName]);
};
